
















import { Component, Prop, Vue, Model, Emit } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component
export default class Input extends Vue {
  @Prop(String) private name: String;
  @Prop(String) private value: String;
  @Prop(String) private type: String;

  private hasFocus: boolean = false;

  @Emit()
  input(e: any) {
    return e.target.value;
  }

  get isActive(): boolean {
    return (
      this.value !== '' ||
      (this.hasFocus && (this.value === '' || this.value === undefined))
    );
  }

  private onFocus() {
    this.hasFocus = true;
  }

  private onBlur() {
    this.hasFocus = false;
  }
}
